
var Model = require("../types/Model.js");
var xtend = require("xtend");
var Promise = require("promise");

module.exports = Model({
	name: "incomingrequests",
	init: init,
	uninit: uninit,
	listeners: listeners,

	_requests: null,
	_people: null,
	_ready: false,

	refresh: refresh,
	recalculate: recalculate,
});

function init() {
	this._requests = [];
	this._people = {};

	this.push([]);
}

function uninit() {
	this._requests = null;
	this._people = null;
}

function listeners() {
	return {
		"mqtt:$/contacts/requests/in/new": handle_new,
		"mqtt:$/contacts/requests/in/accepted": clear_request,
		"mqtt:$/contacts/requests/in/denied": clear_request,
		"mqtt:$/contacts/requests/in/cancelled": clear_request,
		"connectivity:online": refresh,
		"people:updated": handle_people_update,
		"loadchecker:ready": initial_load,
	};
}

function initial_load() {
	this._ready = true;
	this.refresh();
}

function handle_people_update(people) {
	this._people = people;
	this.recalculate();
	this.push(merge_with_people(people, this._requests));
}

function recalculate() {
	this.push(merge_with_people(this._people, this._requests));
}

function merge_with_people(people, requests) {
	return requests
		.filter(function(request){
			return people[request.from];
		})
		.map(function (request) {
			return xtend(request, {
				from: people[request.from]
			});
		});
}

function handle_new(data) {
	this._requests.push(data);
	process_requests.call(this, this._requests);
	this.recalculate();
}

function clear_request(data) {
	var id = data._id;
	this._requests = this._requests.filter(function (request) {
		return request._id !== id;
	});
	this.recalculate();
}

function refresh() {
	if(!this._ready) return Promise.resolve([]);
	return this.api.contacts.requests
		.incoming(true)
		.then(process_requests.bind(this))
		.catch(console.error.bind(console));
}

function process_requests(requests) {
	var ids = get_all_ids(requests);
	this._requests = requests;
	this.emit("people:trigger:add", {
		lean: true,
		who: ids
	});
}

function get_all_ids(requests) {
	return Object.keys(requests.reduce(function (result, request) {
		result[request.from] = true;
		return result;
	}, {}));
}
